import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';
import { SoftwareOptionsService } from '@core/companySoftwareOptions/service/softwareOptions.service';
import { ShellContextService } from 'app/services/shell-context/shell-context.service';
import { Utils } from '@shared/utils.service';
import { FaceliftStore } from './facelift.store';

@Injectable({ providedIn: 'root' })
export class UiFaceliftService {

    constructor(
        private readonly faceliftStore: FaceliftStore,
        private readonly shellContextService: ShellContextService,
        private readonly softwareOptionsService: SoftwareOptionsService,
        private readonly utils: Utils
    ) { }

    initOrUpdateFaceliftAvailability(): void {
        // isFaceliftEnabled$ uses take(1) internally so the subscription self-completes.
        this.isFaceliftEnabled$.subscribe((isFaceliftEnabled) => {
            this.faceliftStore.update({ isFaceliftEnabled });
        });
    }

    private get isFaceliftEnabled$(): Observable<boolean> {
        return this.shellContextService.selectedCompanyId$.pipe(
            filter((companyId) => companyId !== 0),
            distinctUntilChanged(),
            take(1),
            switchMap((companyId) => this.softwareOptionsService.getCompanySoftwareOptionsKeys(companyId, true)),
            map((softwareOptions) => {
                if (softwareOptions) {
                    const isHostedOnScanner = this.utils.isScanner();
                    const isFaceliftEnabledForScanner = softwareOptions.includes('cswo_EnableWebUiFaceliftScanner') && isHostedOnScanner;
                    const isFaceliftEnabledForMyitero = softwareOptions.includes('cswo_EnableWebUiFaceliftMyitero');
                    return isFaceliftEnabledForMyitero || isFaceliftEnabledForScanner;
                }
                return false;
            })
        );
    }
}
